import { ADD_SYSTEM_TAB } from "../../framework/tab/tabUtilsConstants";

export const initial_state_system = {
  type: ADD_SYSTEM_TAB,
  label: "System",
  allowMultipleTabs: false,
};


